"use strict";

var _classCallCheck = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/createClass");

exports.implementation =
/*#__PURE__*/
function () {
  function NavigatorPluginsImpl() {
    _classCallCheck(this, NavigatorPluginsImpl);
  }

  _createClass(NavigatorPluginsImpl, [{
    key: "javaEnabled",
    value: function javaEnabled() {
      return false;
    }
  }]);

  return NavigatorPluginsImpl;
}();